import { Collapse, Stack } from "@mui/material";
import { Box } from "@mui/system";
import { useLocation, useNavigate } from "react-router";
import { MenuDefinition, menuForRole } from "./MenuDefinition";
import { useRole } from "hooks/useRole";
import RenderMenuItem from "./RenderMenuItem";

export interface MenuProps {
    minimal: boolean
}

export function LinkMenu(props: MenuProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const { role } = useRole();

    return (
        <Stack sx={{
            marginTop: "30px"
        }}>
            {
                // NS-753
                menuForRole(MenuDefinition, role).itens.map(x => RenderMenuItem({
                    item: x,
                    minimal: props.minimal,
                    path: location.pathname,
                    navigate,
                })[0])
            }
            <Collapse sx={{ flex: 1 }} in={!props.minimal} orientation={"horizontal"} >
                <Box sx={{ width: "220px" }}></Box>
            </Collapse>

        </Stack>
    );
}